export default class SummertimeFamilyBBQ {
  constructor() {
    this.state = {
      ball: null,
    };

    this.init();
  }

  init() {
    this.handleScroll();
    this.handleBallSelector();
    this.handleReset();
  }

  handleReset() {
    const $arrow = $('.js-btn-reset');

    $arrow.click((e) => {
      if ($('.js-hero-' + this.state.ball).hasClass('active')) {
        $('.js-hero-' + this.state.ball).removeClass('active');
        $('.js-hero-2').removeClass('deactive');
        $('.js-hero-1').removeClass('deactive').addClass('active');
      }

      $('html, body').animate(
        {
          scrollTop: 0,
        },
        {
          duration: 1000,
          complete: () => {
            $('.js-page-' + this.state.ball).fadeOut(500, () => {
              $('.js-page-1').fadeIn(500);
            });
          },
        }
      );
    });
  }

  handleScroll() {
    $(window).scroll(function () {
      if ($(window).scrollTop() + $(window).height() > $(document).height() / 2) {
        if (!$('.js-scroll-arrow').hasClass('rotated')) {
          $('.js-scroll-arrow').addClass('rotated');
        }

        if ($('.js-hero-1').hasClass('active')) {
          $('.js-hero-1').removeClass('active').addClass('deactive');
          $('.js-hero-2').addClass('active');
        }
      } else if ($(window).scrollTop() + $(window).height() < $(document).height() / 2) {
        if ($('.js-scroll-arrow').hasClass('rotated')) {
          $('.js-scroll-arrow').removeClass('rotated');
        }

        if ($('.js-hero-2').hasClass('active')) {
          $('.js-hero-2').removeClass('active');
          $('.js-hero-1').removeClass('deactive').addClass('active');
        }
      }
    });

    const $arrow = $('.js-scroll-arrow');

    $arrow.click((e) => {
      if ($(e.currentTarget).hasClass('rotated')) {
        $('html, body').animate({ scrollTop: 0 }, 'slow');
      } else {
        $('html, body').animate({ scrollTop: $(document).height() }, 'slow');
      }
    });
  }

  handleCounter() {
    console.info('SummertimeFamilyBBQ.handleCounter()');

    const $status = $('.js-slider-counter-' + this.state.ball);
    const $slickElement = $('.slider-' + this.state.ball);

    $slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
      //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });
  }

  handleBallSelector() {
    const $balls = $('ul.ball-selector').children('li.ball');

    $balls.click((e) => {
      this.state.ball = $(e.currentTarget).data('ball');
      console.info(this.state.ball);

      if ($('.js-hero-1').hasClass('active')) {
        $('.js-hero-1').removeClass('active').addClass('deactive');
        $('.js-hero-' + this.state.ball).addClass('active');
      } else if ($('.js-hero-2').hasClass('active')) {
        $('.js-hero-2').removeClass('active').addClass('deactive');
        $('.js-hero-' + this.state.ball).addClass('active');
      }

      $('html, body').animate(
        {
          scrollTop: 0,
        },
        {
          duration: 1000,
          complete: () => {
            $('.js-page-1').fadeOut(500, () => {
              $('.js-page-' + this.state.ball).fadeIn(500);

              if (!$('.slider-' + this.state.ball).hasClass('slick-initialized')) {
                $('.slider-' + this.state.ball).slick({
                  dots: false,
                  infinite: true,
                  prevArrow: $('#slick-prev-' + this.state.ball),
                  nextArrow: $('#slick-next-' + this.state.ball),
                });

                this.handleCounter();
              }
            });
          },
        }
      );
    });
  }
}
